// 認証関連 API（auth / mfa / password）。
// 2026-05-15 リファクタで src/api.ts から分離。
import { request, fetchCsrfToken, setCsrfToken } from './_request'

// === 認証 ===
export interface LoginResult {
  user?: import('../types').User
  csrfToken?: string
  mfaRequired?: boolean
  mfaSetupRequired?: boolean
  passwordExpired?: boolean
  error?: string
}

export const auth = {
  checkSetup: () => request<{ needsSetup: boolean }>('/auth/check-setup'),
  setup: async (data: {
    name: string;
    email: string;
    password: string;
    companyName?: string;
    fiscalYearStartMonth?: number;
  }) => {
    await fetchCsrfToken()
    return request('/auth/setup', { method: 'POST', body: JSON.stringify(data) })
  },
  login: async (email: string, password: string, totp?: string) => {
    await fetchCsrfToken()
    const result = await request<LoginResult>('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password, totp }),
    })
    if (result.csrfToken) setCsrfToken(result.csrfToken)
    return result
  },
  logout: () => request('/auth/logout', { method: 'POST' }),
  me: () => request<{ user: import('../types').User; permissions: import('../types').Permissions; isSetupSession?: boolean }>('/auth/me'),
}

// === MFA（多要素認証） ===
export const mfa = {
  status: () =>
    request<{ enabled: boolean; verifiedAt: string | null; lastUsedAt: string | null }>(
      '/auth/mfa/setup'
    ),
  start: () =>
    request<{ secret: string; uri: string }>('/auth/mfa/setup', {
      method: 'POST',
      body: '{}',
    }),
  verify: async (code: string) => {
    const result = await request<{ ok: boolean; backupCodes: string[]; csrfToken?: string }>(
      '/auth/mfa/setup',
      { method: 'PUT', body: JSON.stringify({ code }) }
    )
    // 一時セッションから昇格した場合は新しいCSRFトークンが返る
    if (result.csrfToken) setCsrfToken(result.csrfToken)
    return result
  },
  disable: (password: string, code: string) =>
    request<{ ok: boolean }>('/auth/mfa/setup', {
      method: 'DELETE',
      body: JSON.stringify({ password, code }),
    }),
}

// === パスワード変更 ===
export const password = {
  change: (currentPassword: string, newPassword: string) =>
    request<{ ok: boolean }>('/auth/password', {
      method: 'POST',
      body: JSON.stringify({ currentPassword, newPassword }),
    }),
}
